module.exports = __webpack_public_path__ + "img/78.b896540d.jpg";